import { render, staticRenderFns } from "./VwaSettingsFullSize.vue?vue&type=template&id=cf606b04&"
import script from "./VwaSettingsFullSize.vue?vue&type=script&lang=ts&"
export * from "./VwaSettingsFullSize.vue?vue&type=script&lang=ts&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./VwaSettingsFullSize.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports